module.exports = function getResource(label, vars = []) {
    let resources = {
        ready: 'Prêt à obtenir votre récompense?',
        joinNow: 'S’inscrire',
        alreadyBI: 'Déjà membre Beauty Insider?',
        signIn: 'Ouvrir une session'
    };

    return resources[label];
};
